module.exports = __webpack_public_path__ + "img/banner-speak.5ac5e253.svg";